export default __webpack_public_path__ + "static/media/notfound.d39296de.png";